import React from 'react';

const LoadingSpinner = ({ orientation = 'vertical' }) => {
  const isHorizontal = orientation === 'horizontal';

  return (
    <div
      className={`app-loading flex w-full items-center justify-center ${isHorizontal ? 'min-h-20 px-4 py-3' : 'min-h-[200px] flex-col p-8'}`}
    >
      <div
        className={`app-loading-indicator relative flex ${isHorizontal ? 'items-center' : 'flex-col items-center'}`}
      >
        <div
          className={`app-loading-spinner relative shrink-0 ${isHorizontal ? 'h-8 w-8' : 'h-12 w-12'}`}
        >
          <span className='absolute h-full w-full animate-ping rounded-full bg-primary/20 opacity-75'></span>
          <div className='relative flex h-full w-full animate-spin items-center justify-center rounded-full border-4 border-gray-100 border-t-primary shadow-sm'></div>
        </div>

        <div
          className={`app-loading-caption flex flex-col items-center ${isHorizontal ? 'mx-2' : 'mt-4'} space-y-1`}
        >
          <span className='text-sm font-semibold text-gray-700'>Memuat Data</span>
          <span className='text-xs text-gray-400'>Mohon tunggu sebentar...</span>
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
